var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 215,
    viewBox: "0 0 375 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3268",
    "data-name": "Rectangle 3268",
    width: 375,
    height: 215,
    transform: "translate(0 64)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28690",
    "data-name": "Group 28690",
    transform: "translate(2102 146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3269",
    "data-name": "Rectangle 3269",
    width: 375,
    height: 215,
    transform: "translate(-2102 -146)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23929",
    "data-name": "Mask Group 23929",
    transform: "translate(-2102 -210)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38056",
    "data-name": "Path 38056",
    d: "M163.516,178.759c53.055-23.285,67.873-74.513,64.866-111.378-4.2-51.436-29.111-85.916-104.561-56.653C80.378,27.576,48.111,29.584,19.086,66.335c-31.7,40.135-46.555,196.244,144.429,112.424",
    transform: "translate(260.625 157.309)",
    fill: "#fff369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38057",
    "data-name": "Path 38057",
    d: "M-1671.826,1387.032s-192.5,28.278-111.63,86.013,52.806,88.633-108.141,138.54",
    transform: "translate(2071 -1342)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertHeaderBg);
export default __webpack_public_path__ + "static/media/convert-header-bg.127d110ad0fab45c6d5dc790de3dbf29.svg";
export { ForwardRef as ReactComponent };